<template>
  <div>
    <v-row justify="center">
      <v-dialog
        persistent
        v-model="show"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click.stop="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ WindowLable }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container class="mt-5">
            <v-stepper v-model="e1">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" step="1">
                  Project
                  <span v-if="tabOne" small class="red--text">{{
                    tabOneMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 2" step="2">
                  <div v-if="projectData.analysisLevel == 'substation'">
                    Substation Profile
                  </div>
                  <div v-if="projectData.analysisLevel == 'feeder'">
                    Feeder Profile
                  </div>
                  <div v-if="projectData.analysisLevel == 'dt'">DT Profile</div>
                  <div
                    v-if="
                      projectData.analysisLevel !== 'dt' &&
                      projectData.analysisLevel !== 'feeder' &&
                      projectData.analysisLevel !== 'substation'
                    "
                  >
                    Profile
                  </div>
                  <span v-if="tabTwo" small class="red--text">{{
                    tabTwoMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 3" step="3">
                  Technology
                  <span v-if="tabThree" small class="red--text">{{
                    tabThreeMessage
                  }}</span>
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="e1 > 4" step="4">
                  VODER
                  <span v-if="tabFour" small class="red--text">{{
                    tabFourMessage
                  }}</span>
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-form class="px-3" ref="formProject">
                  <v-stepper-content step="1">
                    <v-card width="500" class="mx-auto mt-9" flat>
                      <v-card-text>
                        <v-row mx-10>
                          <v-col>
                            <v-text-field
                              v-model="ProjectData.analysisLevel"
                              readonly
                            >
                              <template v-slot:label> Analysis level </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row mx-10>
                          <v-col>
                            <v-text-field
                              v-model="ProjectData.technologyType"
                              readonly
                            >
                              <template v-slot:label> Technology </template>
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <v-text-field v-model="ProjectData.title" readonly>
                          <template v-slot:label> Project Name </template>
                        </v-text-field>
                      </v-card-text>
                    </v-card>
                    <v-card-actions class="justify-center">
                      <v-btn outlined color="primary" @click="tabOne">
                        <template ref=""> Next </template>
                      </v-btn>
                    </v-card-actions>
                  </v-stepper-content>
                </v-form>

                <v-stepper-content step="2">
                  <v-card width="600" class="mx-auto mt-9" flat>
                    <v-card-text>
                      <v-card flat outlined class="mb-10">
                        <v-card-title>
                          <div v-if="projectData.analysisLevel == 'substation'">
                            Substation Profile
                            <!-- <Tooltips :Tooltip="substationProfileTooltip" /> -->
                          </div>
                          <div v-if="projectData.analysisLevel == 'feeder'">
                            Feeder Load Profile
                            <!-- <Tooltips :Tooltip="htLoadProfileTooltip" /> -->
                          </div>
                          <div v-if="projectData.analysisLevel == 'dt'">
                            DT Profile
                            <!-- <Tooltips :Tooltip="dtLoadProfileTooltip" /> -->
                          </div>
                          <v-spacer></v-spacer>
                        </v-card-title>
                        <div class="mx-10">
                          <v-form class="px-3" ref="formProfile">
                            <div v-if="ProjectData.loadProfileId"></div>
                            <v-select
                              v-if="ProjectData.loadProfileId"
                              v-model="ProjectData.loadProfileId"
                              :items="dbFileEntity"
                              item-text="title"
                              item-value="_id"
                              label="Select Existing Profile"
                              readonly
                            />

                            <div v-if="!ProjectData.loadProfileTitle == null">
                              <v-text-field
                                v-if="ProjectData.loadProfileTitle"
                                v-model="ProjectData.loadProfileTitle"
                                readonly
                              >
                                <template v-slot:label> Profile Name </template>
                              </v-text-field>
                            </div>

                            <div v-if="!ProjectData.loadProfile == null">
                              <v-text-field
                                v-if="!ProjectData.loadProfileId"
                                v-model="ProjectData.loadProfile"
                                readonly
                              >
                                <template v-slot:label> Profile Name </template>
                              </v-text-field>
                            </div>
                            <div>
                              <template v-if="!isExistingProfileSelection">
                                <v-text-field
                                  label="Existing File"
                                  v-model="ProjectData.LoadProfileFile"
                                  readonly
                                ></v-text-field>
                                <v-file-input
                                  label="File input"
                                  v-model="ProjectData.feederDataCsvFile"
                                  readonly
                                ></v-file-input>
                              </template>
                              <div v-if="ProjectData.feederData">
                                <v-text-field
                                  v-if="ProjectData.feederData.substationName"
                                  v-model="
                                    ProjectData.feederData.substationName
                                  "
                                  readonly
                                >
                                  <template v-slot:label>
                                    Name of Substation
                                  </template>
                                </v-text-field>
                              </div>

                              <v-text-field
                                v-if="ProjectData.analysisLevel === 'dt'"
                                v-model="ProjectData.feederData.dtName"
                                readonly
                              >
                                <template v-slot:label> Name of DT </template>
                              </v-text-field>

                              <v-text-field
                                v-if="
                                  ProjectData.analysisLevel === 'feeder' ||
                                  ProjectData.analysisLevel === 'substation'
                                "
                                v-model="feederName"
                                readonly
                              >
                                <template v-slot:label>
                                  Name of Feeder
                                </template>
                              </v-text-field>
                              <div
                                v-if="ProjectData.analysisLevel == 'substation'"
                              >
                                <v-text-field
                                  v-model="
                                    ProjectData.feederData.totalCapacityMVA
                                  "
                                  type="number"
                                  readonly
                                >
                                  <template v-slot:label>
                                    Total capacity (MVA)
                                  </template>
                                </v-text-field>

                                <v-text-field
                                  v-model="
                                    ProjectData.feederData
                                      .incomingFeederVoltageKV
                                  "
                                  type="number"
                                  readonly
                                >
                                  <template v-slot:label>
                                    Incoming feeder voltage (kV)
                                  </template>
                                </v-text-field>
                                <v-text-field
                                  v-model="
                                    ProjectData.feederData
                                      .outgoingFeederVoltageKV
                                  "
                                  type="number"
                                  readonly
                                >
                                  <template v-slot:label>
                                    Outgoing feeder voltage (kV)
                                  </template>
                                </v-text-field>
                              </div>

                              <v-row>
                                <v-col>
                                  <v-layout row wrap ml-0>
                                    <v-flex>
                                      <v-text-field
                                        label="Pincode"
                                        v-model="ProjectData.feederData.pincode"
                                        class="width:100px"
                                        readonly
                                      >
                                        <template v-slot:label>
                                          Pincode
                                        </template>
                                      </v-text-field>
                                    </v-flex>
                                    <v-flex mt-4>
                                      <Tooltips :Tooltip="pincodeTooltip" />
                                    </v-flex>
                                  </v-layout>
                                </v-col>
                                <v-col>
                                  <v-text-field
                                    v-model="ProjectData.feederData.stateName"
                                    label="state"
                                    readonly
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>

                              <v-text-field
                                v-model="ProjectData.feederData.feederType"
                                label="Feeder Types"
                                readonly
                              >
                              </v-text-field>

                              <v-text-field
                                v-if="ProjectData.analysisLevel === 'feeder'"
                                v-model="ProjectData.feederData.feederVoltageKV"
                                label="eeder Voltage (kV)"
                                readonly
                              >
                              </v-text-field>
<!-- 
                              <v-text-field
                                v-if="ProjectData.analysisLevel === 'feeder'"
                                label="Sanctioned Load (MW)"
                                v-model="
                                  ProjectData.feederData.sanctionedLoadMW
                                "
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                readonly
                              /> -->

                              <v-text-field
                                v-if="
                                  ProjectData.analysisLevel === 'substation'
                                "
                                label="Number of Feeders"
                                v-model="ProjectData.feederData.feederCount"
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                readonly
                              />

                              <div
                                v-if="
                                  ProjectData.analysisLevel === 'dt' ||
                                  ProjectData.analysisLevel === 'substation'
                                "
                              >
                                <v-text-field
                                  label="Power Factor"
                                  v-model="ProjectData.feederData.powerFactor"
                                  class="inputField input-name p-3 styled-input"
                                  type="number"
                                  readonly
                                />
                              </div>

                              <div v-if="ProjectData.analysisLevel === 'dt'">
                                <v-row>
                                  <v-col>
                                    <v-text-field
                                      label="DT Capacity KVA"
                                      v-model="
                                        ProjectData.feederData.dtCapacityKVA
                                      "
                                      class="
                                        inputField
                                        input-name
                                        p-3
                                        styled-input
                                      "
                                      type="number"
                                      readonly
                                    />
                                  </v-col>
                                </v-row>
                                <v-text-field
                                  label="Primary Voltage (kV)"
                                  v-model="
                                    ProjectData.feederData.primaryVoltage
                                  "
                                  class="inputField input-name p-3 styled-input"
                                  type="number"
                                  readonly
                                />
                              </div>

                              <v-text-field
                                v-if="ProjectData.analysisLevel === 'dt'"
                                label="Secondary Voltage (kV)"
                                v-model="
                                  ProjectData.feederData.secondaryVoltage
                                "
                                class="inputField input-name p-3 styled-input"
                                type="number"
                                readonly
                              />

                              <v-layout ml-0>
                                <v-flex>
                                  <v-text-field
                                    v-model="
                                      ProjectData.feederData.feederLengthKm
                                    "
                                    type="number"
                                    readonly
                                  >
                                    <template v-slot:label>
                                      <div
                                        v-if="
                                          ProjectData.analysisLevel === 'dt'
                                        "
                                      >
                                        Total LT line length (km)
                                      </div>
                                      <div
                                        v-if="
                                          ProjectData.analysisLevel == 'feeder'
                                        "
                                      >
                                        Feeder length (km)
                                      </div>
                                      <div
                                        v-if="
                                          ProjectData.analysisLevel ==
                                          'substation'
                                        "
                                      >
                                        Total Feeder length (km)
                                      </div>
                                    </template>
                                  </v-text-field>
                                </v-flex>
                                <v-flex mt-4>
                                  <Tooltips :Tooltip="feederLengthTooltip" />
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-form>
                        </div>
                      </v-card>

                      <v-card flat outlined>
                        <v-card-title>
                          State level load profile
                          <Tooltips :Tooltip="stateLevelTooltip" />
                          <v-spacer></v-spacer>
                        </v-card-title>
                        <div class="ml-10">
                          <v-form class="px-3" ref="formStateProfile">
                            <div>
                              <v-row>
                                <v-col>
                                  <div
                                    v-if="
                                      ProjectData.feederData.stateLevelProfile
                                    "
                                  >
                                    <v-select
                                      v-if="
                                        ProjectData.feederData.stateLevelProfile
                                          .profileId
                                      "
                                      v-model="
                                        ProjectData.feederData.stateLevelProfile
                                          .profileId
                                      "
                                      :items="stateLevelProfiles"
                                      item-text="title"
                                      item-value="_id"
                                      label="Select Existing Profile"
                                      readonly
                                    />
                                  </div>
                                </v-col>
                                <v-col> </v-col>
                              </v-row>
                              <div>
                                <v-text-field
                                  v-if="
                                    ProjectData.stateLevelLoadProfileTitle &&
                                    ProjectData.stateLevelLoadProfileTitle !=
                                      'null'
                                  "
                                  v-model="
                                    ProjectData.stateLevelLoadProfileTitle
                                  "
                                  readonly
                                >
                                  <template v-slot:label>
                                    State Level Profile Name
                                  </template>
                                </v-text-field>

                                <v-text-field
                                  v-if="ProjectData.stateLevelLoadProfileFile"
                                  label="State level profile File"
                                  v-model="
                                    ProjectData.stateLevelLoadProfileFile.name
                                  "
                                  readonly
                                >
                                </v-text-field>

                                <div
                                  v-if="
                                    ProjectData.feederData.stateLevelProfile
                                  "
                                >
                                  <v-text-field
                                    v-if="
                                      ProjectData.feederData.stateLevelProfile
                                        .peakLoadDemandMW
                                    "
                                    v-model="
                                      ProjectData.feederData.stateLevelProfile
                                        .peakLoadDemandMW
                                    "
                                    type="number"
                                    class="
                                      inputField
                                      input-name
                                      p-3
                                      styled-input
                                    "
                                    readonly
                                  >
                                    <template v-slot:label>
                                      Peak load demand (MW)
                                    </template>
                                  </v-text-field>

                                  <v-text-field
                                    v-if="
                                      ProjectData.feederData.stateLevelProfile
                                        .peakLoadDemandMW
                                    "
                                    v-model="
                                      ProjectData.feederData.stateLevelProfile
                                        .peakLoadEventTime
                                    "
                                    readonly
                                    class="
                                      inputField
                                      input-name
                                      p-3
                                      styled-input
                                    "
                                  >
                                    <template v-slot:label>
                                      Peak Load Event Time
                                    </template>
                                  </v-text-field>
                                </div>
                              </div>
                            </div>
                          </v-form>
                        </div>
                      </v-card>

                    <!--v-text-field
                      v-model="ProjectData.stateLevelDistributedSolarEnergyCapacityAddition"
                      type="number"
                      class="ml-2 mt-5 inputField p-3 styled-input"
                      style="width: 500px"
                      readonly
                    >
                      <template v-slot:label>
                        State level distributed solar energy capacity addition
                      </template>
                    </v-text-field-->

                      <div style="margin-left: -25px">
                        <v-expansion-panels flat>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              expand-icon="mdi-menu-down"
                              class="font-weight-bold"
                            >
                              Advanced inputs (optional)
                            </v-expansion-panel-header>

                            <v-form class="px-3" ref="formProfileAdvance">
                              <v-expansion-panel-content>
                                <v-text-field
                                  label="Analysis period (years)"
                                  v-model="
                                    ProjectData.feederData.analysisPeriod
                                  "
                                  readonly
                                />
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      label="Upper limit for capacity upgradation (%)"
                                      v-model="
                                        ProjectData.feederData
                                          .capacityUpgradationUpperLimit
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      readonly
                                    />
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="
                                        upperLimitForCapacityUpgradationTooltip
                                      "
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      label="Percentage of load shifted after upgradation"
                                      v-model="
                                        ProjectData.feederData
                                          .loadShiftedAfterUpgradation
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      readonly
                                    />
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="
                                        percentageOfLadShiftedAfterUpgradationTooltip
                                      "
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-text-field
                                      v-model="
                                        ProjectData.feederData
                                          .yearlyChangeInLoadPercent
                                      "
                                      class="
                                        inputField
                                        input-name2
                                        p-3
                                        styled-input
                                      "
                                      :rules="inputRules"
                                      readonly
                                    >
                                      <template v-slot:label>
                                        Yearly change in load (%)
                                      </template>
                                    </v-text-field>
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="yearlyChangeInLoadTooltip"
                                    />
                                  </v-flex>
                                </v-layout>

                                <v-layout row wrap ml-0>
                                  <v-flex>
                                    <v-row mx-10>
                                      <v-col>
                                        <v-select
                                          v-model="
                                            ProjectData.feederData.conductorType
                                              .title
                                          "
                                          :items="conductorTypes"
                                          item-text="title"
                                          item-value="title"
                                          label="Type of conductor"
                                          class="
                                            inputField
                                            input-name2
                                            p-3
                                            styled-input
                                          "
                                          readonly
                                        />
                                      </v-col>
                                      <v-col> </v-col>
                                    </v-row>
                                  </v-flex>
                                  <v-flex mt-4>
                                    <Tooltips
                                      :Tooltip="typeOfConductorTooltip"
                                    />
                                  </v-flex>
                                </v-layout>

                                <div>
                                  <v-text-field
                                    v-model="
                                      ProjectData.feederData.conductorType
                                        .resistanceOhmsPerKm
                                    "
                                    readonly
                                    type="number"
                                  >
                                    <template v-slot:label>
                                      Resistance (ohms/km)
                                    </template>
                                  </v-text-field>
                                  <v-text-field
                                    v-model="
                                      ProjectData.feederData.conductorType
                                        .reactanceOhmsPerKm
                                    "
                                    type="number"
                                    readonly
                                  >
                                    <template v-slot:label>
                                      Reactance (ohms/km)
                                    </template>
                                  </v-text-field>
                                  <v-text-field
                                    v-model="
                                      ProjectData.feederData.conductorType
                                        .peakCurrentCarryingCapacityAmps
                                    "
                                    type="number"
                                    readonly
                                  >
                                    <template v-slot:label>
                                      Peak current carrying capacity (Amps)
                                    </template>
                                  </v-text-field>
                                </div>
                              </v-expansion-panel-content>
                            </v-form>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card-actions class="justify-center">
                    <v-btn outlined color="primary" @click="e1 = 1">Back</v-btn>

                    <v-btn outlined color="primary" @click="tabTwo()"
                      >Next</v-btn
                    >
                  </v-card-actions>
                </v-stepper-content>
                <v-form class="px-3" ref="formTechnology">
                  <v-stepper-content step="3">
                    <div
                      v-if="!ProjectData.technologyData"
                      class="mx-auto justify-center"
                      style="text-align: center"
                    >
                      <h3>Technology data not found!</h3>
                    </div>
                    <v-card
                      width="500"
                      class="mx-auto mt-9"
                      flat
                      v-if="ProjectData.technologyData"
                    >
                      <v-card-text>
                        <v-text-field
                          v-if="
                            ProjectData.technologyType == 'solar' ||
                            ProjectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="ProjectData.technologyData.solarCapacity"
                          type="number"
                          readonly
                        >
                          <template v-slot:label>
                            Solar capacity (MW)
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-if="
                            ProjectData.technologyType == 'solar' ||
                            ProjectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="
                            ProjectData.technologyData
                              .interconnectionLocationSolar
                          "
                          readonly
                        >
                          <template v-slot:label>
                            Interconnection Location Solar
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-if="
                            ProjectData.technologyType == 'storage' ||
                            ProjectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="
                            ProjectData.technologyData
                              .inverterCapacityForStorage
                          "
                          readonly
                          type="number"
                          class="inputField input-name p-3 styled-input"
                        >
                          <template v-slot:label>
                            Inverter capacity for storage (MW)
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-if="
                            ProjectData.technologyType == 'storage' ||
                            ProjectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="ProjectData.technologyData.storageCapacity"
                          readonly
                          type="number"
                        >
                          <template v-slot:label>
                            Storage capacity (MWh)
                          </template>
                        </v-text-field>

                        <v-layout row wrap ml-0>
                          <v-flex>
                            <v-text-field
                              v-if="
                                ProjectData.technologyType === 'storage' ||
                                ProjectData.technologyType ===
                                  'solar_plus_storage'
                              "
                              v-model="
                                ProjectData.technologyData
                                  .interconnectionLocationStorage
                              "
                              readonly
                            >
                              <template v-slot:label>
                                Interconnection Location Storage
                              </template>
                            </v-text-field>
                          </v-flex>
                          <v-flex mt-4>
                            <Tooltips
                              :Tooltip="interconnectionLocationStorageTooltip"
                              v-if="
                                projectData.technologyType == 'storage' ||
                                projectData.technologyType ==
                                  'solar_plus_storage'
                              "
                            />
                          </v-flex>
                        </v-layout>

                        <v-text-field
                          v-if="
                            ProjectData.technologyType == 'storage' ||
                            ProjectData.technologyType == 'solar_plus_storage'
                          "
                          v-model="
                            ProjectData.technologyData
                              .storageChargingDischargingStrategy
                          "
                          readonly
                        >
                          <template v-slot:label>
                            Storage charging/discharging strategy
                          </template>
                        </v-text-field>
                      </v-card-text>
                    </v-card>
                    <v-card-actions class="justify-center">
                      <v-btn outlined color="primary" @click="e1 = 2"
                        >Back</v-btn
                      >

                      <v-btn outlined color="primary" @click="tabThree()"
                        >Next</v-btn
                      >
                    </v-card-actions>
                  </v-stepper-content>
                </v-form>

                <v-stepper-content step="4">
                  <div v-if="!ProjectData.voderData" style="text-align: center">
                    <h3>Voder data not found!</h3>
                  </div>
                  <v-card
                    width="800"
                    class="mx-auto mt-9"
                    flat
                    v-if="ProjectData.voderData"
                  >
                    <v-card-text>
                      <v-form class="px-3" ref="formVoder">
                        <v-card flat outlined>
                          <v-card-title>
                            Marginal cost of energy to be replaced (INR/kWh)
                            <Tooltips :Tooltip="marginalCostOfEnergyTooltip" />
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-if="
                                  ProjectData.marginalCostOfReplacedEnergyMetricType
                                "
                                v-model="
                                  ProjectData.marginalCostOfReplacedEnergyMetricType
                                "
                                label="Marginal cost of energy to be replaced"
                                readonly
                              />
                            </v-col>

                            <v-col>
                              <div></div>

                              <v-text-field
                                v-if="
                                  ProjectData.marginalCostOfReplacedEnergyMetricType ===
                                    'hourly_cost_of_supply_for_one_year' ||
                                  ProjectData.marginalCostOfReplacedEnergyMetricType ===
                                    'cost_as_per_iex_data'
                                "
                                v-model="
                                  ProjectData
                                    .marginalCostOfReplacedEnergyMetricFile.name
                                "
                                readonly
                                label="File Name"
                              />
                              <div
                                v-if="
                                  ProjectData.marginalCostOfReplacedEnergyMetricType ===
                                  'marginal_cost_of_generator_to_be_replaced'
                                "
                              >
                                <v-text-field
                                  v-model="
                                    ProjectData.marginalCostOfReplacedEnergyMetricData
                                  "
                                  readonly
                                >
                                  <template v-slot:label> value </template>
                                </v-text-field>
                              </div>
                              <div
                                v-if="
                                  ProjectData.marginalCostOfReplacedEnergyMetricType ===
                                  'database'
                                "
                              >
                                <v-text-field
                                  v-model="
                                    marginalCostOfReplacedEnergyMetricData
                                  "
                                  readonly
                                  label="Database"
                                />
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                        <div v-if="ProjectData.voderData">
                          <v-text-field
                            v-if="ProjectData.voderData.avgTransmissionLosses"
                            v-model="
                              ProjectData.voderData.avgTransmissionLosses
                            "
                            readonly
                            type="number"
                          >
                            <template v-slot:label>
                              Average transmission losses (%)
                            </template>
                          </v-text-field>
                        </div>
                      </v-form>

                      <v-expansion-panels flat>
                        <v-expansion-panel>
                          <v-expansion-panel-header
                            expand-icon="mdi-menu-down"
                            class="font-weight-bold"
                          >
                            Advanced inputs (optional)
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <div v-if="ProjectData.voderData">
                              <v-layout row wrap ml-0>
                                <v-flex>
                                  <v-text-field
                                    label="Transmission capacity cost (INR/MW)"
                                    v-model="
                                      ProjectData.voderData
                                        .transmissionCapacityCost
                                    "
                                    class="
                                      inputField
                                      input-name2
                                      p-3
                                      styled-input
                                    "
                                    readonly
                                    type="number"
                                  />
                                </v-flex>
                                <v-flex mt-4>
                                  <Tooltips
                                    :Tooltip="transmissionCapacityCostTooltip"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap ml-0>
                                <v-flex>
                                  <v-text-field
                                    label="Generation capacity cost (INR/MW)"
                                    v-model="
                                      ProjectData.voderData
                                        .generationCapacityCost
                                    "
                                    class="
                                      inputField
                                      input-name2
                                      p-3
                                      styled-input
                                    "
                                    readonly
                                    type="number"
                                  />
                                </v-flex>
                                <v-flex mt-4>
                                  <Tooltips
                                    :Tooltip="generationCapacityCostTooltip"
                                  />
                                </v-flex>
                              </v-layout>

                              <v-text-field
                                label="Discount Factor"
                                v-model="ProjectData.voderData.discountFactor"
                                type="number"
                                readonly
                              />

                              <v-text-field
                                label="Interest Rate"
                                v-model="ProjectData.voderData.interestRate"
                                type="number"
                                readonly
                              />

                              <v-card class="mt-9" flat>
                                <v-card flat outlined>
                                  <v-card-text>
                                    <v-card-title>
                                      Cost of Upgradation
                                    </v-card-title>

                                    <v-text-field
                                      label="Cost In Lakhs"
                                      v-model="
                                        ProjectData.voderData.upgradationCost
                                          .costInLakhs
                                      "
                                      type="number"
                                      readonly
                                    />
                                  </v-card-text>
                                </v-card>
                              </v-card>

                              <v-text-field
                                label="Cost of CO2 (INR/Kg)"
                                v-model="
                                  ProjectData.voderData.emissionCosts
                                    .emissionCostCo2
                                "
                                type="number"
                                readonly
                              />
                              <v-text-field
                                label="Cost of NO2 (INR/Kg)"
                                v-model="
                                  ProjectData.voderData.emissionCosts
                                    .emissionCostNo2
                                "
                                type="number"
                                readonly
                              />

                              <v-text-field
                                label="Cost of SO2 (INR/Kg)"
                                v-model="
                                  ProjectData.voderData.emissionCosts
                                    .emissionCostSo2
                                "
                                type="number"
                                readonly
                              />
                              <v-text-field
                                label="Cost of PM2.5 (INR/Kg)"
                                v-model="
                                  ProjectData.voderData.emissionCosts
                                    .emissionCostSPM2_5
                                "
                                type="number"
                                readonly
                              />
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-card-text>
                  </v-card>
                  <v-card-actions class="justify-center">
                    <v-btn outlined color="primary" @click="e1 = 3">Back</v-btn>
                  </v-card-actions>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { bus } from "../main.js";
import { formatInputDate, displayDateTime } from "@/utility/dateTime.js";
import AdminFeederStore from "@/services/adminfeederstore.js";
import DataList from "@/services/dataliststore.js";
import ProjectService from "@/services/ProjectService.js";

import Tooltips from "@/components/tooltips.vue";
import TooltipsData from "@/services/lableTooltips.js";
import PincodeService from "@/services/pincodeservice.js";
import csvFile from "@/services/csvFile";
import dataService from "@/libs/dataService.js";
import staticMasterdataService from "@/libs/staticMasterData.js";

import { projectStatus } from "../utility/constants";
export default {
  name: "projectDetails",
  props: ["visible", "ProjectData", "WindowLable"],
  components: {
    Tooltips,
  },
  data() {
    return {
      marginalCostOfReplacedEnergyMetricData: "",
      profileTitle: "",
      feederName: "",
      confirmationDialogProps: {
        message: "",
        title: "",
        isVisible: false,
        onClose: () => {},
        isNegativeShow: true,
        positiveActionText: "Yes",
        negativeActionText: "No",
      },
      showdtCapacityKVAOthers: false,
      analysislevel: "",
      isChangedFeederProfileCSV: false,
      isChangedStateProfileCSV: false,
      isChangedMarginalCSV: false,
      tempLoadProfileId: null,
      isStateLevelCsvChanged: false,
      isLoadProfileCsvChange: false,
      status: "",
      oldProjectTitle: "",
      oldProjectTechnologyType: "",
      isSowfinalMessage: false,
      isShowExistingStateLevelProfile: false,
      isShowExistFile: false,
      isShowStateLevelPrfoleTitle: false,
      isShowStateLevelProfileFile: false,
      isShowStateLevelPeakLoadDemand: false,
      isShowStateLevelPeakLoadEvent: false,

      isOpenProfileDivision: true,
      isOpenStateProfileDivision: true,
      profileSelection: "existing_profile",
      stateProfileSelection: "_existing_profile",
      isShowField: true,
      timeProps: {
        useSeconds: false,
        ampmInTitle: false,
      },
      upgradationCostMappingDetails: [],
      marginalCostOfReplacedEnergyMetricType: "",
      marginalCostLable: "",
      changeData: "",

      isAnalysisLevelReadOnly: true,
      isTechnologyReadOnly: false,
      isLoadProfileReadOnly: true,
      isProjectTitleReadOnly: true,
      isStateLevelProfileReadOnly: true,
      isConductorTypeReadOnly: true,
      isMarginalCostOfEnergyReadOnly: true,

      ShowChangeConfirmation: false,
      confirmationMessage: "",
      analysisLevels: [],
      technologyTypes: [],
      feederVoltageKVs: [],
      secondaryVoltages: [],
      dtCapacityKVAs: [],
      othersDtCapacityKVA: null,
      conductorTypes: [],
      marginalCostOfReplacedEnergyMetricRecords: [],
      solarInterconnectionLocations: [],
      storageChargingDischargingStrategies: [],
      storageInterconnectionLocations: [],
      selectedProfile: null,
      loadProfilesAll: [],
      selectedMarginalCostOfReplacedEnergyMetricData: "",
      feederTypes: [],
      selected: "",
      e1: 1,
      errorMsg: "",
      Notification: false,
      dtLoadProfileTooltip: "",
      substationProfileTooltip: "",
      htLoadProfileTooltip: "",
      pincodeTooltip: "",
      feederLengthTooltip: "",
      sanctionedTooltip: "",
      stateLevelTooltip: "",
      yearlyChangeInLoadTooltip: "",
      typeOfConductorTooltip: "",
      marginalCostOfEnergyTooltip: "",
      interconnectionLocationStorageTooltip: "",
      stateLevelLoadTooltip: "",
      upperLimitForCapacityUpgradation: "",
      percentageOfLadShiftedAfterUpgradationTooltip: "",
      upperLimitForCapacityUpgradationTooltip: "",
      transmissionCapacityCostTooltip: "",
      costOfUpgradationTootip: "",

      conductortype: "",
      generationCapacityCostTooltip: "",
      selectedProfileFile: null,
      changeinloadyearly: "",
      dbFileEntity: [],
      stateLevelProfiles: [],
      substationProfileFileList: [],
      htProfileFileList: [],
      dtProfileFileList: [],
      inputRules: [(v) => !!v || "This field is required"],
      SolarCapacityInputRules: {
        required: (value) => !!value || "This field is required",
        feeder: (v) =>
          v <=
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.732) /
              1000 ||
          `value should be below or equal to ${
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.732) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000
          }`,

        substation: (v) =>
          v <= this.projectData.totalCapacityMVA ||
          `value should be below or equal to ${this.projectData.totalCapacityMVA}`,
      },

      storageCapacityInputRules: {
        required: (value) => !!value || "This field is required",
        feeder: (v) =>
          v <=
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.25) /
              1000 ||
          `value should be below or equal to ${
            (this.projectData.feederVoltageKV *
              this.projectData.peakCurrentCarryingCapacityAmps *
              1.25) /
            1000
          }`,

        dt: (v) =>
          v <=
            (this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000) ||
          `value should be below or equal to ${
            this.showdtCapacityKVAOthers
              ? this.othersDtCapacityKVA / 1000
              : this.projectData.dtCapacityKVA / 1000
          }`,

        substation: (v) =>
          v <= this.projectData.totalCapacityMVA ||
          `value should be below or equal to ${this.projectData.totalCapacityMVA}`,
      },

      marginalCostSelectList: [],
      tabOneMessage: "",
      tabTwoMessage: "",
      tabThreeMessage: "",
      tabFourMessage: "",
      selecteddtCapacityKVA: null,
      selectedsecondaryVoltage: null,
      marginalCostOfReplacedEnergyMetricDataFile: null,
      response: [],

      projectData: {
        fileData: {
          isNewLoadProfileFile: false,
          isLoadLevelFileExist: false,
          isNewStateLevelLodProfileFile: false,
          isStateLevelFileExist: false,
          isNewMetricFile: false,
        },
        _id: "",
        analysisLevel: "",
        technologyType: "",
        title: "",
        loadProfileId: null,
        profileType: "",
        loadProfileTitle: "",
        feederDataCsvFile: [],
        substationName: "",
        dtName: "",
        feederName: "",
        totalCapacityMVA: "",
        incomingFeederVoltageKV: "",
        outgoingFeederVoltageKV: "",
        pincode: "",
        stateName: "",
        feederType: "",
        feederVoltageKV: "",
        voltageLevelsKV: "",
        sanctionedLoadMW: "",
        feederCount: "",
        powerFactor: "",
        dtTapping: "",
        dtCapacityKVA: "",
        primaryVoltage: "",
        secondaryVoltage: "",
        feederLengthKm: "",
        profileId: null,
        LoadProfileFile: "",
        stateLevelLoadProfileFile: "",
        stateLevelLoadProfileTitle: "",
        stateLevelCsvFile: [],
        peakLoadDemandMW: "",
        peakLoadEventTime: "",
        analysisPeriod: "",
        capacityUpgradationUpperLimit: "",
        loadShiftedAfterUpgradation: "",
        yearlyChangeInLoadPercent: "",
        conductorTypeTitle: "",
        resistanceOhmsPerKm: "",
        reactanceOhmsPerKm: "",
        peakCurrentCarryingCapacityAmps: "",
        solarCapacity: null,
        interconnectionLocationSolar: null,
        interconnectionLocationStorage: null,
        inverterCapacityForStorage: null,
        storageCapacity: null,
        storageChargingDischargingStrategy: null,
        marginalCostOfReplacedEnergyMetricType: "",
        marginalCostOfReplacedEnergyMetricDataFile: "",
        marginalCostOfReplacedEnergyMetricData: "",
        marginalCostOfReplacedEnergyMetricRecords: [],
        avgTransmissionLosses: null,
        transmissionCapacityCost: "",
        generationCapacityCost: "",
        discountFactor: "",
        interestRate: 6.5,
        costInLakhs: "",
        emissionCostCo2: "",
        emissionCostSo2: "",
        emissionCostNo2: "",
        emissionCostSPM2_5: "",
        status: "inputs_required",
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close", this.response);
        }
      },
    },
    isExistingProfileSelection() {
      return this.profileSelection === "existing_profile";
    },
    isExistingStateProfileSelection() {
      return this.stateProfileSelection === "existing_profile";
    },
    isPeakLoadDemandMWAndPeakLoadEventTimeSection() {
      if (this.stateLevelProfile.title.length > 0) {
        return false;
      } else {
        return true;
      }
    },

    isEditable() {
      return false;
    },
  },
  created() {
    this.getLoadProfiles();
    // this.fillAnalysisLevels();
    // this.fillTechnologyTypes();
    // this.fillFeederTypes();
    // this.fillDTCapacityKVA();

    // this.fillFeederVoltageKV();
    this.fillConductorTypes();
    // this.fillToolTips();

    this.fillMarginalCostSelectList();
    this.getLoadProfiles();

    // this.fillStorageChargingDischargingStrategy();
    this.fillMarginalCostOfReplacedEnergyMetricData();
    // this.fillTechnologyLocationData();
  },
  methods: {
    showRunAnalysisDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.startAnalysis;
        this.confirmationDialogProps.title = "VODER analysis begins";
        this.confirmationDialogProps.message =
          "Project data cannot be modified once analysis begins. Do you want to proceed?";
        this.confirmationDialogProps.negativeActionText = "No";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },
    showAnalysisProcessDialog() {
      if (this.e1 === 4) {
        this.confirmationDialogProps.onClose = this.redirectToDashboard;
        this.confirmationDialogProps.title = "The analysis is in progress";
        this.confirmationDialogProps.message =
          "The analysis is in progress and will take a few minutes. You will receive an email once the analysis is completed.";
        // this.confirmationDialogProps.message ="The analysis for this project will begin now and all project data can no more be modified. Do you want to proceed?";
        this.confirmationDialogProps.positiveActionText = "Ok";
        this.confirmationDialogProps.isVisible = true;
        this.confirmationDialogProps.isNegativeShow = false;
        this.confirmationDialogProps = { ...this.confirmationDialogProps };
      }
    },
    redirectToDashboard() {
      this.resetDialogProps();
      this.$emit("close", this.response);
      // this.$router.push("/dashboard");
    },
    startAnalysis(shouldStart) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        negativeActionText: "No",
      };
      if (shouldStart) {
        this.updateProjectStatus(
          this.projectData._id,
          projectStatus.ANALYSIS_READY_DER
        );
        this.resetDialogProps();
      }
    },
    resetDialogProps() {
      this.confirmationDialogProps = {
        ...this.confirmationDialogProps,
        isVisible: false,
        message: "",
        title: "",
        negativeActionText: "No",
        onClose: () => {},
      };
    },

    updateProjectStatus(projectId, status) {
      ProjectService.updateProjectStatus(projectId, status)
        .then(() => {
          bus.$emit(
            "analysisStartNotification",
            "Analysis has started succesfully."
          );
          this.resetDialogProps();
          this.showAnalysisProcessDialog();
        })
        .catch(() => {
          bus.$emit(
            "errorNotification",
            "An error occured when starting the analysis for the project"
          );
        });
    },

    saveCSVFile(id, type, file, data) {
      if (type) {
        if (type === "feeder") {
          ProjectService.saveFile(id, "feeder", file, data)
            .then(() => {
              return true;
            })
            .catch((error) => {
              return false;
            });
        }
        if (type === "state") {
          return true;
        }
        if (type === "margine") {
          return true;
        }
      }
      return false;
    },
    onChangedFeederProfileCSV() {
      this.isChangedFeederProfileCSV = true;
    },
    onChangedStateProfileCSV() {
      this.isChangedStateProfileCSV = true;
    },
    onChangedMarginalCSV() {
      this.isChangedMarginalCSV = true;
    },
    resetTechnology() {
      this.$refs.formTechnology.reset();
    },
    resetVoder() {
      this.$refs.formVoder.reset();
    },
    closeBox() {
      this.isSowfinalMessage = false;
    },
    onChangePeakLoadDemand() {
      if (this.projectData.peakLoadDemandMW !== "") {
        this.isShowStateLevelPrfoleTitle = false;
        this.isShowStateLevelProfileFile = false;
        this.isShowExistFile = false;
      } else {
        this.isShowExistFile = true;
        this.isShowStateLevelPrfoleTitle = true;
        this.isShowStateLevelProfileFile = true;
      }
    },

    onStateLevelPrfoleTitle() {
      if (this.projectData.stateLevelLoadProfileTitle !== "") {
        this.isShowExistFile = false;
        this.isShowStateLevelPeakLoadDemand = false;
        this.isShowStateLevelPeakLoadEvent = false;
      } else {
        this.isShowExistFile = true;
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
        this.isShowStateLevelPrfoleTitle = true;
      }
    },
    onProfileSelectionChange() {
      this.isOpenProfileDivision = true;
      if (this.profileSelection === "existing_profile") {
        this.projectData.loadProfileId = this.tempLoadProfileId;
        // this.selectedProfile = "";
        // this.feederData.title = "";
        // this.feederData.csvFile = null;
      } else {
        this.projectData.loadProfileId = null;
        // this.resetProfileFields();
      }
    },
    onStateProfileSelectionChange() {
      this.isOpenStateProfileDivision = true;
      if (this.stateProfileSelection === "existing_profile") {
        this.isShowExistingStateLevelProfile = true;
        this.isShowStateLevelProfileFile = false;
      } else {
        this.isShowExistingStateLevelProfile = false;
        this.projectData.profileId = null;
        this.isShowStateLevelProfileFile = true;
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
        this.isShowStateLevelPrfoleTitle = true;
      }
    },

    fillTechnologyLocationData() {
      this.solarInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationSolar();
      this.storageInterconnectionLocations =
        staticMasterdataService.getInterconnectionLocationStorage();
    },
    showConfirmBox(option) {
      this.ShowChangeConfirmation = true;
      this.changeData = option;
      if (option === "Analysis") {
        this.confirmationMessage =
          "Changing the of Analysis type will clear profile data, Are you sure want to change the analysis type?";
      } else if (option === "Technology") {
        this.confirmationMessage =
          "Changing the Technology type will clear technology data, Are you sure want to change the Technology type?";
      } else if (option === "LoadProfile") {
        this.confirmationMessage =
          "Changing the Profile will delete profile data, Are you sure want to change the Profile?";
      } else if (option === "StateLevelProfile") {
        this.confirmationMessage =
          "Changing the State Leve Profile will delete state level profile data, Are you sure want to change the state level profile?";
      } else if (option === "conductorType") {
        this.confirmationMessage =
          "Changing the conductorType will delete conductor data, Are you sure want to change the conductorType?";
      } else if (option === "MarginalCostOfEnergy") {
        this.confirmationMessage =
          "Changing the Marginal Cost Of Energy will delete MarginalCost Of Energy data, Are you sure want to change the Marginal Cost Of Energy?";
      }
    },

    async isShowStateLevelPrfile() {
      if (this.projectData.profileId) {
        this.isShowExistingStateLevelProfile = true;
      }

      if (this.projectData.stateLevelLoadProfileFile !== "") {
        this.isShowExistFile = true;
        this.isShowStateLevelProfileFile = true;
      }

      if (this.projectData.peakLoadDemandMW !== "") {
        this.isShowStateLevelPeakLoadDemand = true;
        this.isShowStateLevelPeakLoadEvent = true;
      }

      // this.isShowExistFile =true
      // this.isShowStateLevelPrfoleTitle= true
      // this.isShowStateLevelProfileFile= true
      // this.isShowStateLevelPeakLoadDemand=true
      // this.isShowStateLevelPeakLoadEvent=true
    },

    showStateLevelPrfile() {
      this.isShowExistFile = true;
      this.isShowStateLevelPrfoleTitle = true;
      this.isShowStateLevelProfileFile = true;
      this.isShowStateLevelPeakLoadDemand = true;
      this.isShowStateLevelPeakLoadEvent = true;
    },
    resetProfile() {
      this.$refs.formProfile.reset();
      this.isOpenProfileDivision = false;
    },
    resetStateProfile() {
      this.isOpenStateProfileDivision = false;
      this.$refs.formStateProfile.reset();
    },
    clearDTInputFields() {
      this.resetProfile();
    },
    changeConfirm(e) {
      this.confirmationDialogProps.isVisible = false;
      this.confirmationDialogProps = { ...this.confirmationDialogProps };
      if (e === true) {
        this.submit(false);
        this.e1 = 3;
      } else {
        this.submit(false);
        this.e1 = 2;
      }
      // this.ShowChangeConfirmation = false;
      // if (e && this.changeData === "Analysis") {
      //   this.isAnalysisLevelReadOnly = false;
      // } else if (!e && this.changeData === "Analysis") {
      //   this.isAnalysisLevelReadOnly = true;
      // }

      // if (e && this.changeData === "Technology") {
      //   this.isTechnologyReadOnly = false;
      // } else if (!e && this.changeData === "Technology") {
      //   this.isTechnologyReadOnly = true;
      // }

      // if (e && this.changeData === "LoadProfile") {
      //   this.isLoadProfileReadOnly = false;
      //   this.clearDTInputFields();
      // } else if (!e && this.changeData === "LoadProfile") {
      //   this.isLoadProfileReadOnly = true;
      // }

      // if (e && this.changeData === "StateLevelProfile") {
      //   this.stateProfileSelection = "existing_profile";
      //   this.isShowExistingStateLevelProfile = true;
      //   this.resetStateProfile();
      //   this.showStateLevelPrfile();
      //   this.isStateLevelProfileReadOnly = false;
      //   this.projectData.isStateLevelFileExist = false;
      // } else if (!e && this.changeData === "StateLevelProfile") {
      //   this.isStateLevelProfileReadOnly = true;
      // }

      // if (e && this.changeData === "conductorType") {
      //   this.isConductorTypeReadOnly = false;
      // } else if (!e && this.changeData === "conductorType") {
      //   this.isConductorTypeReadOnly = true;
      // }

      // if (e && this.changeData === "MarginalCostOfEnergy") {
      //   this.isMarginalCostOfEnergyReadOnly = false;
      //   this.projectData.marginalCostOfReplacedEnergyMetricDataFile = "";
      //   this.marginalCostOfReplacedEnergyMetricData = "";
      //   this.projectData.marginalCostOfReplacedEnergyMetricData = "";
      // } else if (!e && this.changeData === "MarginalCostOfEnergy") {
      //   this.isMarginalCostOfEnergyReadOnly = true;
      // }
    },
    fillMarginalCostSelectList() {
      this.marginalCostSelectList =
        staticMasterdataService.getMarginalCostSelectList();
    },
    fillDTCapacityKVA() {
      this.dtCapacityKVAs = staticMasterdataService.getDTCapacityKVA();
    },
    fillsecondaryVoltage() {
      this.secondaryVoltages = staticMasterdataService.getSecondaryVoltage();
    },
    fillMarginalCostOfReplacedEnergyMetricData() {
      dataService
        .list("marginalCostOfReplacedEnergyRecords/published")
        .then((res) => {
          this.marginalCostOfReplacedEnergyMetricRecords = res;
        });

      if (
        this.marginalCostOfReplacedEnergyMetricRecords &&
        this.ProjectData.marginalCostOfReplacedEnergyMetricType === "database"
      ) {
        //const dbMarginalCostData = this.marginalCostOfReplacedEnergyMetricRecords.find((d)=> {d._id === this.ProjectData.marginalCostOfReplacedEnergyMetricRecord});

        const dbMarginalCostData =
          this.marginalCostOfReplacedEnergyMetricRecords.find(
            (d) =>
              d._id ===
              this.ProjectData.marginalCostOfReplacedEnergyMetricRecord
          );
        if (dbMarginalCostData) {
          this.marginalCostOfReplacedEnergyMetricData =
            dbMarginalCostData.title;
        }
        // console.log('db',dbMarginalCostData)
      }
    },
    fillFeederTypes() {
      dataService.list("feederTypes").then((res) => {
        this.feederTypes = res;
      });
    },
    fillTechnologyTypes() {
      dataService.list("technologyTypes/active").then((res) => {
        this.technologyTypes = res;
      });
    },
    fillConductorTypes() {
      dataService.list("conductorTypes/published").then((res) => {
        this.conductorTypes = res;
        const item = {
          peakCurrentCarryingCapacityAmps: "",
          reactanceOhmsPerKm: "",
          resistanceOhmsPerKm: "",
          title: "Others",
        };
        this.conductorTypes.push(item);
      });
    },
    fillFeederVoltageKV() {
      dataService.list("feederVoltageKV").then((res) => {
        this.feederVoltageKVs = res;
      });
    },
    fillAnalysisLevels() {
      dataService.list("analysisLevels/active").then((res) => {
        this.analysisLevels = res;
      });
    },
    fillStorageChargingDischargingStrategy() {
      this.storageChargingDischargingStrategies =
        staticMasterdataService.getStorageChargingDischargingStrategy();
    },
    async getLoadProfiles() {
      const res = await DataList.methods.fetchData("loadProfiles/published");
      this.loadProfilesAll = res;
      this.stateLevelProfiles = this.loadProfilesAll.filter(
        (profile) => profile.profileType === "state_level"
      );

      // this.fillMasterConstent();
      //   this.upgradationCostMappingDetails =
      //     await this.getAllupgradationCostMappings();
      //   this.FillData();

      //   this.isShowStateLevelPrfile();
    },
    onFileChange() {
      // this.csvFile = this.projectData.feederDataCsvFile;
      // this.testcsv();
    },
    async testcsv() {
      const a = await csvFile.isValideCSV(this.csvFile);
    },
    onChangeExistingProfile() {
      if (
        this.ProjectData.analysisLevel === "feeder" ||
        this.ProjectData.analysisLevel === "substation"
      ) {
        const profileValues = this.loadProfilesAll.find(
          (profile) => profile._id === this.ProjectData.loadProfileId
        );
        this.feederName = profileValues.feederName;
      }

      // this.fillLoadProfileData(profileValues[0]);
    },
    onDTChange() {
      if (this.projectData.dtCapacityKVA === "others") {
        this.showdtCapacityKVAOthers = true;
      } else {
        this.showdtCapacityKVAOthers = false;
        //  this.othersDtCapacityKVA=null;
      }
      this.getDTUpgradationCostMappings();
    },
    onSecondaryVoltageChange() {
      this.getDTUpgradationCostMappings();
      this.getSubstationUpgradationCostMappings();
    },
    fillLoadProfileData(profile) {
      this.projectData.pincode = profile.pincode;
      this.projectData.stateName = profile.stateName;
      this.projectData.feederLengthKm = profile.feederLengthKm;
      this.profileType = profile.profileType;
      this.projectData.feederType = profile.feederType;

      this.projectData.loadProfileTitle =
        profile.loadProfileTitle !== null ? profile.loadProfileTitle : "";
      this.projectData.stateLevelLoadProfileTitle =
        profile.stateLevelLoadProfileTitle
          ? profile.stateLevelLoadProfileTitle
          : "";
      if (profile.profileType === "dt") {
        this.projectData.substationName = profile.substationName;
        this.projectData.dtName = profile.dtName;
        this.projectData.powerFactor = profile.powerFactor;
        this.projectData.dtTapping = profile.dtTapping;
        this.projectData.primaryVoltage = profile.primaryVoltage;

        this.projectData.dtCapacityKVA = profile.dtCapacityKVA;

        this.projectData.secondaryVoltage = profile.secondaryVoltage;
        this.getDTUpgradationCostMappings();
      }
      if (profile.profileType === "substation") {
        this.projectData.powerFactor = profile.powerFactor;
        this.projectData.totalCapacityMVA = profile.totalCapacityMVA;
        this.projectData.incomingFeederVoltageKV =
          profile.incomingFeederVoltageKV;
        this.projectData.outgoingFeederVoltageKV =
          profile.outgoingFeederVoltageKV;
        this.getSubstationUpgradationCostMappings();
      }
      if (profile.profileType === "feeder") {
        // this.projectData.sanctionedLoadMW = profile.sanctionedLoadMW;
        this.projectData.feederDtName = profile.feederName;
        this.projectData.feederVoltageKV = profile.feederVoltageKV;

        this.getFeederUpgradationCostMappings();
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    tabOne() {
      this.fillExistinfProfiles();
      this.onChangeExistingProfile();
      this.e1 = 2;
    },
    tabTwo() {
      this.e1 = 3;
    },
    tabThree() {
      this.fillMarginalCostOfReplacedEnergyMetricData();

      this.e1 = 4;
    },
    tabFour() {
      this.e1 = 4;
    },
    onPincodeChange() {
      if (this.projectData.pincode.length >= 6) {
        this.getStateName();
      } else {
        this.projectData.stateName = "";
      }
    },
    async getStateName() {
      this.projectData.stateName = PincodeService.methods.getStateName(
        this.projectData.pincode
      );
    },
    async getConductorTypeDetails() {
      const res = await DataList.methods.fetchData("conductorType");
      this.conductortypeDetails = res;
    },
    async getSubstationProfileFileList() {
      const res = await DataList.methods.fetchData("substationProfileFileList");
      this.substationProfileFileList = res;
    },
    async getHTProfileFileList() {
      const res = await DataList.methods.fetchData("htProfileFileList");
      this.htProfileFileList = res;
    },
    async getDTProfileFileList() {
      const res = await DataList.methods.fetchData("dtProfileFileList");
      this.dtProfileFileList = res;
    },
    selectMarginalCostItem(item) {
      this.marginalCostOfReplacedEnergyMetricType = item;
    },
    fillExistinfProfiles() {
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === this.ProjectData.analysisLevel
      );
    },
    onChangeAnalysisLevel() {
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === this.projectData.analysisLevel
      );
    },
    fillCostUpgradationtoolTip() {
      const _costOfUpgradationTootip = TooltipsData.methods.getTooltips(
        "costOfUpgradationTootip"
      );
      this.costOfUpgradationTootip = _costOfUpgradationTootip.find(
        (d) => d.key === this.analysislevel
      ).value;
    },
    setLoadProfile(project) {
      if (project.loadProfileId) {
        this.projectData.loadProfileId = project.loadProfileId;
      }
      if (project.loadProfileFile) {
        this.isOpenProfileDivision = true;
        this.profileSelection = "NA";
        this.projectData.LoadProfileFile = project.loadProfileFile.name;
        this.projectData.loadProfileTitle =
          project.loadProfileTitle !== "null" &&
          project.loadProfileTitle !== null
            ? project.loadProfileTitle
            : "";
        this.projectData.feederDataCsvFile = project.loadProfileFile;
      }
    },
    setStateLevelProfile(project) {
      if (typeof project.feederData.stateLevelProfile === "undefined") {
        this.projectData.stateLevelLoadProfileFile =
          project.stateLevelLoadProfileFile;
        this.projectData.stateLevelLoadProfileTitle =
          project.stateLevelLoadProfileTitle;
        this.projectData.stateLevelCsvFile = project.stateLevelLoadProfileFile;

        if (project.stateLevelLoadProfileFile) {
          this.projectData.isStateLevelFileExist = true;
        }
      }

      if (typeof project.feederData.stateLevelProfile !== "undefined") {
        if (
          typeof project.feederData.stateLevelProfile.profileId !== "undefined"
        ) {
          this.projectData.profileId =
            project.feederData.stateLevelProfile.profileId;
        } else {
          this.projectData.peakLoadEventTime = displayDateTime(
            project.feederData.stateLevelProfile.peakLoadEventTime
          );
          this.projectData.peakLoadDemandMW =
            project.feederData.stateLevelProfile.peakLoadDemandMW;
        }
      }
    },
    setMarginalCostData(project) {
      // this.projectData.marginalCostOfReplacedEnergyMetricType =
      //   project.marginalCostOfReplacedEnergyMetricType;
      // this.marginalCostOfReplacedEnergyMetricType =
      //   project.marginalCostOfReplacedEnergyMetricType;

      if (
        this.ProjectData.marginalCostOfReplacedEnergyMetricType ===
        "marginal_cost_of_generator_to_be_replaced"
      ) {
        this.projectData.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricData;
      }
      if (
        this.projectData.marginalCostOfReplacedEnergyMetricType ===
          "cost_as_per_iex_data" ||
        this.projectData.marginalCostOfReplacedEnergyMetricType ===
          "hourly_cost_of_supply_for_one_year"
      ) {
        this.projectData.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricFile.name;
        this.projectData.marginalCostOfReplacedEnergyMetricDataFile =
          project.marginalCostOfReplacedEnergyMetricFile;
      }
      if (
        this.ProjectData.marginalCostOfReplacedEnergyMetricType === "database"
      ) {
        this.marginalCostOfReplacedEnergyMetricData =
          project.marginalCostOfReplacedEnergyMetricRecord;
      }
    },
    setTechnologyData(project) {
      if (project.technologyType === "solar") {
        if (project.technologyData) {
          this.projectData.solarCapacity = project.technologyData.solarCapacity;
          this.projectData.interconnectionLocationSolar =
            project.technologyData.interconnectionLocationSolar;
        }
      }

      if (project.technologyType === "storage") {
        if (project.technologyData) {
          this.projectData.inverterCapacityForStorage =
            project.technologyData.inverterCapacityForStorage;
          this.projectData.interconnectionLocationStorage =
            project.technologyData.interconnectionLocationStorage;
          this.projectData.storageCapacity =
            project.technologyData.storageCapacity;
          this.projectData.storageChargingDischargingStrategy =
            project.technologyData.storageChargingDischargingStrategy;
        }
      }
      if (project.technologyType === "solar_plus_storage") {
        if (project.technologyData) {
          this.projectData.inverterCapacityForStorage =
            project.technologyData.inverterCapacityForStorage;
          this.projectData.interconnectionLocationStorage =
            project.technologyData.interconnectionLocationStorage;
          this.projectData.storageCapacity =
            project.technologyData.storageCapacity;
          this.projectData.solarCapacity = project.technologyData.solarCapacity;
          this.projectData.interconnectionLocationSolar =
            project.technologyData.interconnectionLocationSolar;
          this.projectData.storageChargingDischargingStrategy =
            project.technologyData.storageChargingDischargingStrategy;
        }
      }
    },
    setFeederData(project) {
      this.status = project.status;
      this.projectData._id = project._id;
      this.projectData.analysisLevel = project.analysisLevel;
      this.projectData.technologyType = project.technologyType;
      this.projectData.title = project.title;
      this.projectData.substationName = project.feederData.substationName;
      this.projectData.dtName = project.feederData.dtName;
      this.projectData.feederName = project.feederData.feederName;
      this.projectData.totalCapacityMVA = project.feederData.totalCapacityMVA;
      this.projectData.feederCount = project.feederData.feederCount;
      this.projectData.incomingFeederVoltageKV =
        project.feederData.incomingFeederVoltageKV;
      this.projectData.outgoingFeederVoltageKV =
        project.feederData.outgoingFeederVoltageKV;
      this.projectData.pincode = project.feederData.pincode;
      this.projectData.stateName = project.feederData.stateName;
      this.projectData.feederType = project.feederData.feederType;
      this.projectData.feederVoltageKV = project.feederData.feederVoltageKV;
      this.projectData.sanctionedLoadMW = project.feederData.sanctionedLoadMW;
      this.projectData.powerFactor = project.feederData.powerFactor;
      this.projectData.dtTapping = project.feederData.dtTapping;

      // console.log('dt capacity',  project.feederData.dtCapacityKVA);

      const index = this.dtCapacityKVAs.findIndex(
        (item) => item === project.feederData.dtCapacityKVA
      );
      if (index < 0) {
        this.projectData.dtCapacityKVA = "others";
        this.showdtCapacityKVAOthers = true;
        this.othersDtCapacityKVA = project.feederData.dtCapacityKVA;
      } else {
        this.showdtCapacityKVAOthers = false;
        this.projectData.dtCapacityKVA = project.feederData.dtCapacityKVA;
      }
      // console.log(index);
      // console.log(fruits[index]); // blueberries

      this.projectData.primaryVoltage = project.feederData.primaryVoltage;
      this.projectData.secondaryVoltage = project.feederData.secondaryVoltage;
      this.projectData.feederLengthKm = project.feederData.feederLengthKm;
      this.projectData.profileType = project.feederData.profileType;

      // analysisPeriod,capacityUpgradationUpperLimit,loadShiftedAfterUpgradation shifted from voder to feeder

      this.projectData.analysisPeriod = project.feederData.analysisPeriod;
      this.projectData.capacityUpgradationUpperLimit =
        project.feederData.capacityUpgradationUpperLimit;
      this.projectData.loadShiftedAfterUpgradation =
        project.feederData.loadShiftedAfterUpgradation;
      this.projectData.yearlyChangeInLoadPercent =
        project.feederData.yearlyChangeInLoadPercent;
      this.projectData.conductorTypeTitle =
        project.feederData.conductorType.title;
      this.projectData.resistanceOhmsPerKm =
        project.feederData.conductorType.resistanceOhmsPerKm;
      this.projectData.reactanceOhmsPerKm =
        project.feederData.conductorType.reactanceOhmsPerKm;

      this.projectData.peakCurrentCarryingCapacityAmps =
        project.feederData.conductorType.peakCurrentCarryingCapacityAmps;
    },

    async fillCostInLakhs() {
      if (this.projectData.analysisLevel === "feeder") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.feederVoltageKV &&
          this.projectData.feederType
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (f) =>
              f.analysisLevel === this.projectData.analysisLevel &&
              f.feederType === this.projectData.feederType &&
              f.voltageLevelsKV == this.projectData.feederVoltageKV
          );
          if (costMaping) {
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }
      }
      if (this.projectData.analysisLevel === "substation") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.outgoingFeederVoltageKV
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (cm) => cm.analysisLevel === this.projectData.analysisLevel
          );
          this.projectData.costInLakhs = costMaping.costInLakhs;
        }
      }

      if (this.projectData.analysisLevel === "dt") {
        if (
          this.projectData.analysisLevel &&
          this.projectData.primaryVoltage &&
          this.projectData.dtCapacityKVA
        ) {
          const costMaping = this.upgradationCostMappingDetails.find(
            (f) =>
              f.analysisLevel == this.projectData.analysisLevel &&
              f.voltageLevelsKV == this.projectData.primaryVoltage &&
              f.dtCapacityKVA == this.projectData.dtCapacityKVA
          );
          this.projectData.costInLakhs = costMaping.costInLakhs;
        }
      }
    },
    async fillMasterConstent() {
      const masterConstants =
        await AdminFeederStore.methods.getAllMasterConstant();
      this.masterConstants = masterConstants[masterConstants.length - 1];
      this.projectData.transmissionCapacityCost =
        this.masterConstants.transmissionCapacityCostINR_MW;
      this.projectData.generationCapacityCost =
        this.masterConstants.generationCapacityCostINR_MW;
      this.projectData.discountFactor = this.masterConstants.discountFactor;
      this.projectData.emissionCostCo2 =
        this.masterConstants.emissionCosts.emissionCostCo2;
      this.projectData.emissionCostNo2 =
        this.masterConstants.emissionCosts.emissionCostNo2;
      this.projectData.emissionCostSo2 =
        this.masterConstants.emissionCosts.emissionCostSo2;
      this.projectData.emissionCostSPM2_5 =
        this.masterConstants.emissionCosts.emissionCostCo2;
    },
    async setVoderData(project) {
      // const masterConstants =
      //   await AdminFeederStore.methods.getAllMasterConstant();
      // this.masterConstants = masterConstants[masterConstants.length - 1];

      if (project.voderData) {
        if (typeof project.voderData.avgTransmissionLosses !== "undefined") {
          this.projectData.avgTransmissionLosses =
            project.voderData.avgTransmissionLosses;
        }

        if (typeof project.voderData.transmissionCapacityCost !== "undefined") {
          this.projectData.transmissionCapacityCost =
            project.voderData.transmissionCapacityCost;
        }

        if (typeof project.voderData.generationCapacityCost !== "undefined") {
          this.projectData.generationCapacityCost =
            project.voderData.generationCapacityCost;
        }

        if (typeof project.voderData.discountFactor !== "undefined") {
          this.projectData.discountFactor = project.voderData.discountFactor;
        }

        if (typeof project.voderData.interestRate !== "undefined") {
          this.projectData.interestRate = project.voderData.interestRate;
        } else {
          this.projectData.interestRate = 6.5;
        }

        if (
          typeof project.voderData.upgradationCost.voltageLevelsKV !==
          "undefined"
        ) {
          this.projectData.voltageLevelsKV =
            project.voderData.upgradationCost.voltageLevelsKV;
        }
        if (
          typeof project.voderData.upgradationCost.costInLakhs !== "undefined"
        ) {
          this.projectData.costInLakhs =
            project.voderData.upgradationCost.costInLakhs;
        }
        if (
          typeof project.voderData.upgradationCost.emissionCostCo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostCo2 =
            project.voderData.emissionCosts.emissionCostCo2;
        }

        if (
          typeof project.voderData.upgradationCost.emissionCostNo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostNo2 =
            project.voderData.emissionCosts.emissionCostNo2;
        }
        if (
          typeof project.voderData.upgradationCost.emissionCostSo2 ===
          "undefined"
        ) {
          this.projectData.emissionCostSo2 =
            project.voderData.emissionCosts.emissionCostSo2;
        }

        if (
          typeof project.voderData.upgradationCost.emissionCostSPM2_5 ===
          "undefined"
        ) {
          this.projectData.emissionCostSPM2_5 =
            project.voderData.emissionCosts.emissionCostSPM2_5;
        }
      } else {
        if (this.projectData.analysisLevel === "feeder") {
          if (
            this.projectData.analysisLevel &&
            this.projectData.feederVoltageKV &&
            this.projectData.feederType
          ) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (f) =>
                f.analysisLevel === this.projectData.analysisLevel &&
                f.feederType === this.projectData.feederType &&
                f.voltageLevelsKV == this.projectData.feederVoltageKV
            );
            if (costMaping) {
              this.projectData.costInLakhs = costMaping.costInLakhs;
            }
          }
        }

        if (this.projectData.analysisLevel === "substation") {
          if (this.analysisLevel && this.projectData.outgoingFeederVoltageKV) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (cm) => cm.analysisLevel === this.projectData.analysislevel
            );
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }

        if (this.projectData.analysisLevel === "dt") {
          if (
            this.projectData.analysisLevel &&
            this.projectData.primaryVoltage &&
            this.projectData.dtCapacityKVA
          ) {
            const costMaping = this.upgradationCostMappingDetails.find(
              (f) =>
                f.analysisLevel == this.projectData.analysisLevel &&
                f.voltageLevelsKV == this.projectData.primaryVoltage &&
                f.dtCapacityKVA == this.projectData.dtCapacityKVA
            );
            this.projectData.costInLakhs = costMaping.costInLakhs;
          }
        }
        // this.projectData.intrestrate =  this.masterConstants.intrestRate
        // console.log('intrestrate',this.masterConstants)
      }
    },

    async getAllupgradationCostMappings() {
      return await DataList.methods
        .fetchData("upgradationCostMappings")
        .then((res) => {
          return res;
        });
      // this.upgradationCostMappingDetails = res;
    },

    getClonedProjectPayload(projectData, voltageLevelsKV) {
      const payload = {
        status: projectStatus.ANALYSIS_READY_BAU,
        title: projectData.title,
        technologyType: projectData.technologyType,
        feederDtName: projectData.feederDtName,
        isCloned: false,
        analysisLevel: projectData.analysisLevel,
        substationName: projectData.substationName,
        feederData: {
          profileId: projectData.loadProfileId,
          title: projectData.loadProfileTitle,
          csvFile:
            projectData.feederDataCsvFile && this.isChangedFeederProfileCSV
              ? projectData.feederDataCsvFile
              : null,
          profileType: projectData.analysisLevel,
          feederDtName: projectData.feederDtName,
          pincode: projectData.pincode,
          stateName: projectData.stateName,
          feederType: projectData.feederType,
          feederLengthKm: projectData.feederLengthKm
            ? projectData.feederLengthKm
            : null,
          feederVoltageKV: projectData.feederVoltageKV
            ? projectData.feederVoltageKV
            : null,
          sanctionedLoadMW: projectData.sanctionedLoadMW
            ? projectData.sanctionedLoadMW
            : null,
          yearlyChangeInLoadPercent: projectData.yearlyChangeInLoadPercent
            ? projectData.yearlyChangeInLoadPercent
            : null,
          powerFactor: projectData.powerFactor ? projectData.powerFactor : null,
          dtTapping: projectData.dtTapping ? projectData.dtTapping : null,

          // dtCapacityKVA: projectData.dtCapacityKVA
          //   ? projectData.dtCapacityKVA
          //   : null,
          dtCapacityKVA: this.showdtCapacityKVAOthers
            ? this.othersDtCapacityKVA
            : projectData.dtCapacityKVA
            ? projectData.dtCapacityKVA
            : null,

          primaryVoltage: projectData.primaryVoltage
            ? projectData.primaryVoltage
            : null,
          secondaryVoltage: projectData.secondaryVoltage
            ? projectData.secondaryVoltage
            : null,
          incomingFeederVoltageKV: projectData.incomingFeederVoltageKV
            ? projectData.incomingFeederVoltageKV
            : null,
          outgoingFeederVoltageKV: projectData.outgoingFeederVoltageKV
            ? projectData.outgoingFeederVoltageKV
            : null,
          totalCapacityMVA: projectData.totalCapacityMVA
            ? projectData.totalCapacityMVA
            : null,
          feederCount: projectData.feederCount ? projectData.feederCount : null,
          analysisPeriod: projectData.analysisPeriod
            ? projectData.analysisPeriod
            : null,
          capacityUpgradationUpperLimit:
            projectData.capacityUpgradationUpperLimit
              ? projectData.capacityUpgradationUpperLimit
              : null,
          loadShiftedAfterUpgradation: projectData.loadShiftedAfterUpgradation,
          stateLevelProfile: {
            profileId: projectData.profileId ? projectData.profileId : null,
            title: projectData.stateLevelLoadProfileTitle
              ? projectData.stateLevelLoadProfileTitle
              : null,
            peakLoadDemandMW: projectData.peakLoadDemandMW
              ? projectData.peakLoadDemandMW
              : null,
            peakLoadEventTime: formatInputDate(projectData.peakLoadEventTime)
              ? formatInputDate(projectData.peakLoadEventTime)
              : null,
            csvFile:
              projectData.stateLevelCsvFile && this.isChangedStateProfileCSV
                ? projectData.stateLevelCsvFile
                : null,
          },
          conductorType: {
            title: projectData.conductorTypeTitle,
            reactanceOhmsPerKm: projectData.reactanceOhmsPerKm,
            resistanceOhmsPerKm: projectData.resistanceOhmsPerKm,
            peakCurrentCarryingCapacityAmps:
              projectData.peakCurrentCarryingCapacityAmps,
          },
        },
        technologyData: {
          solarCapacity: projectData.solarCapacity
            ? projectData.solarCapacity
            : null,
          interconnectionLocationSolar: projectData.interconnectionLocationSolar
            ? projectData.interconnectionLocationSolar
            : null,
          inverterCapacityForStorage: projectData.inverterCapacityForStorage
            ? projectData.inverterCapacityForStorage
            : null,
          storageCapacity: projectData.storageCapacity
            ? projectData.storageCapacity
            : null,
          interconnectionLocationStorage:
            projectData.interconnectionLocationStorage
              ? projectData.interconnectionLocationStorage
              : null,
          storageChargingDischargingStrategy:
            projectData.storageChargingDischargingStrategy
              ? projectData.storageChargingDischargingStrategy
              : null,
        },
        voderData: {
          marginalCostOfReplacedEnergyMetricType:
            projectData.marginalCostOfReplacedEnergyMetricType
              ? projectData.marginalCostOfReplacedEnergyMetricType
              : null,
          marginalCostOfReplacedEnergyMetricData:
            projectData.marginalCostOfReplacedEnergyMetricData
              ? projectData.marginalCostOfReplacedEnergyMetricData
              : null,
          csvFile:
            projectData.marginalCostOfReplacedEnergyMetricDataFile &&
            this.isChangedMarginalCSV
              ? projectData.marginalCostOfReplacedEnergyMetricDataFile
              : null,
          analysisPeriod: projectData.analysisPerio
            ? projectData.analysisPerio
            : null,
          avgTransmissionLosses: projectData.avgTransmissionLosses
            ? projectData.avgTransmissionLosses
            : null,
          capacityUpgradationUpperLimit:
            projectData.capacityUpgradationUpperLimit
              ? projectData.capacityUpgradationUpperLimit
              : null,
          loadShiftedAfterUpgradation: projectData.loadShiftedAfterUpgradation
            ? projectData.loadShiftedAfterUpgradation
            : null,
          transmissionCapacityCost: projectData.transmissionCapacityCost
            ? projectData.transmissionCapacityCost
            : null,
          generationCapacityCost: projectData.generationCapacityCost
            ? projectData.generationCapacityCost
            : null,
          discountFactor: projectData.discountFactor
            ? projectData.discountFactor
            : null,
          interestRate: projectData.interestRate
            ? projectData.interestRate
            : null,

          upgradationCost: {
            analysisLevel: projectData.analysisLevel,
            voltageLevelsKV: voltageLevelsKV,
            feederType: projectData.feederType,
            costInLakhs: projectData.costInLakhs,
          },
          emissionCosts: {
            emissionCostCo2: projectData.emissionCostCo2,
            emissionCostSo2: projectData.emissionCostSo2,
            emissionCostNo2: projectData.emissionCostNo2,
            emissionCostSPM2_5: projectData.emissionCostSPM2_5,
          },
        },
      };
      return payload;
    },

    fillToolTips() {
      this.substationProfileTooltip =
        TooltipsData.methods.getTooltips("nameOfSubstation");
      this.htLoadProfileTooltip = TooltipsData.methods.getTooltips("htFeeder");
      this.dtLoadProfileTooltip =
        TooltipsData.methods.getTooltips("dtLoadProfile");
      this.pincodeTooltip = TooltipsData.methods.getTooltips("pincode");
      this.feederLengthTooltip =
        TooltipsData.methods.getTooltips("feederLength");
      this.sanctionedTooltip = TooltipsData.methods.getTooltips("sanctioned");
      this.stateLevelTooltip = TooltipsData.methods.getTooltips("stateLevel");
      this.yearlyChangeInLoadTooltip =
        TooltipsData.methods.getTooltips("yearlyChangeInLoad");
      this.typeOfConductorTooltip =
        TooltipsData.methods.getTooltips("typeOfConductor");
      this.marginalCostOfEnergyTooltip = TooltipsData.methods.getTooltips(
        "marginalCostOfEnergy"
      );
      this.interconnectionLocationStorageTooltip =
        TooltipsData.methods.getTooltips("interconnectionLocationStorage");
      this.stateLevelLoadTooltip =
        TooltipsData.methods.getTooltips("stateLevelLoad");
      this.upperLimitForCapacityUpgradation = TooltipsData.methods.getTooltips(
        "upperLimitForCapacityUpgradation"
      );
      this.percentageOfLadShiftedAfterUpgradationTooltip =
        TooltipsData.methods.getTooltips(
          "percentageOfLadShiftedAfterUpgradation"
        );
      this.transmissionCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "transmissionCapacityCost"
      );
      this.generationCapacityCostTooltip = TooltipsData.methods.getTooltips(
        "generationCapacityCost"
      );
    },
    onChangeConductorTypes() {
      const e = this.projectData.conductorTypeTitle;
      if (e === "Others") {
        this.resistanceOhmsPerKm = "";
        this.reactanceOhmsPerKm = "";
        this.peakCurrentCarryingCapacityAmps = "";
        return;
      }
      const conductorTypeDetails = this.conductorTypes.find(
        (x) => x.title === e
      );
      this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
      this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
      this.peakCurrentCarryingCapacityAmps =
        conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    },
    async FillData() {
      const project = { ...this.ProjectData };
      this.oldProjectTitle = project.title;
      this.oldProjectTechnologyType = project.technologyType;
      this.dbFileEntity = this.loadProfilesAll.filter(
        (profile) => profile.profileType === project.analysisLevel
      );

      if (typeof this.ProjectData.isCloned === "undefined") {
        this.ProjectData.isCloned = false;
      }

      if (project.isCloned && project.isCloned === true) {
        this.tempLoadProfileId = this.projectData.loadProfileId;
        this.isLoadProfileReadOnly = false;
        this.isStateLevelProfileReadOnly = false;
      }
      this.fillMasterConstent();
      if (project.feederData) {
        this.setFeederData(project);
        this.setLoadProfile(project);
      }
      if (project.feederData.stateLevelProfile) {
        this.setStateLevelProfile(project);
      }

      this.setVoderData(project);

      if (project.technologyType) {
        this.setTechnologyData(project);
      }
      if (project.marginalCostOfReplacedEnergyMetricType) {
        this.setMarginalCostData(project);
      }
    },

    // setval(e) {
    //   if (e.datasource === "analysisLevels/active") {
    //     this.analysislevel = e.value;
    //     this.dbFileEntity = this.loadProfilesAll.filter(
    //       (profile) => profile.profileType === e.value
    //     );
    //   }
    //   if (e.datasource === "technologyTypes/active") {
    //     this.technologyType = e.value;
    //   }
    //   if (e.datasource === "feederTypes") {
    //     this.feederType = e.value;
    //     this.getFeederUpgradationCostMappings();
    //   }
    //   if (e.datasource === "feederVoltageKV") {
    //     this.feederVoltageKV = e.value;
    //     this.getFeederUpgradationCostMappings();
    //     this.getDTUpgradationCostMappings();
    //   }
    //   if (e.datasource === "conductorTypes/published") {
    //     this.conductortype = e.value;
    //     if (e.value === "Others") {
    //       this.resistanceOhmsPerKm = "";
    //       this.reactanceOhmsPerKm = "";
    //       this.peakCurrentCarryingCapacityAmps = "";
    //       return;
    //     }
    //     const conductorTypeDetails = e.Items.find((x) => x.title === e.value);
    //     this.resistanceOhmsPerKm = conductorTypeDetails.resistanceOhmsPerKm;
    //     this.reactanceOhmsPerKm = conductorTypeDetails.reactanceOhmsPerKm;
    //     this.peakCurrentCarryingCapacityAmps =
    //       conductorTypeDetails.peakCurrentCarryingCapacityAmps;
    //   }
    //   if (e.datasource === "marginalCostOfReplacedEnergyRecords/published") {
    //     this.marginalCostOfReplacedEnergyMetricData = e.Items;
    //   }
    //   if (e.datasource === "solarInterconnectionLocations") {
    //     this.projectData.interconnectionLocationSolar = e.value;
    //   }
    //   if (e.datasource === "Interconnectionlocationstorage") {
    //     this.interconnectionLocationStorage = e.value;
    //   }
    //   if (e.datasource === "chargingdischarging") {
    //     this.storagechargingdischargingstrategy = e.value;
    //   }
    //   if (e.datasource === "FeederLoadProfile") {
    //     this.FeederLoadProfiles = e.value;
    //   }
    //   if (e.datasource === "Statelevelloadprofile") {
    //     this.Statelevelloadprofile = e.value;
    //   }
    //   if (e.datasource === "Projects") {
    //     this.projectname = e.value;
    //   }
    // },

    isFormValidate() {
      if (this.e1 === 1) {
        this.status = "inputs_required";

        if (!this.$refs.formProject.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 2) {
        this.status = "analysis_ready_bau";
        if (
          !this.$refs.formProfile.validate() ||
          !this.$refs.formStateProfile.validate() ||
          !this.$refs.formProfileAdvance.validate()
        ) {
          return false;
        } else {
          return true;
        }
      }

      if (this.e1 === 3) {
        this.status = "analysis_ready_bau";
        if (!this.$refs.formTechnology.validate()) {
          return false;
        } else {
          return true;
        }
      }
      if (this.e1 === 4) {
        this.status = "analysis_ready_der";
        if (!this.$refs.formVoder.validate()) {
          return false;
        } else {
          return true;
        }
      }
    },

    showFinalMessage() {
      if (this.e1 === 4) {
        // this.isSowfinalMessage = true;
        this.showRunAnalysisDialog();
      }
    },
  },
};
</script>